import { useMemo } from 'react';
import { createObjectIntentType } from '../../intent';
import { addRenderIntent } from '../view';
import { getVariantClass, VariantScope } from './core';
export const variantIntent = createObjectIntentType('variantIntent', (createIntent)=>(scope, map)=>{
        const result = {};
        const keys = Object.keys(map);
        for(let i = 0; i < keys.length; i++){
            const key = keys[i];
            const value = map[key];
            if (value) {
                result[`${scope}:${key}`] = Array.isArray(value) ? value.filter((v)=>v != null).map((v)=>getVariantClass(scope, key, v)).join(' ') : getVariantClass(scope, key, value);
            }
        }
        return createIntent(result);
    });
/** @deprecated */ export function deprecatedVariants(map) {
    return variantIntent(VariantScope.Scoped, map);
}
/** @deprecated */ export function deprecatedGlobalVariants(map) {
    return variantIntent(VariantScope.Cascading, map);
}
// @ts-expect-error error TS2345: Argument of type '((scope: VariantScope, map: Variants) => VariantClasses & Intent<any>) & IntentType<VariantClasses & Intent<any>, VariantClasses & Intent<...>>' is not assignable to parameter of type 'IntentType<VariantClasses & Intent<any>, void | Variants>'.
// Types of property 'add' are incompatible.
// Type '(intent: VariantClasses & Intent<any> & Intent<never>, state?: (VariantClasses & Intent<any>) | undefined) => VariantClasses & Intent<...>' is not assignable to type '(intent: VariantClasses & Intent<any> & Intent<never>, state?: void | Variants | undefined) => void | Variants'.
//   Types of parameters 'state' and 'state' are incompatible.
//     Type 'void | Variants | undefined' is not assignable to type '(VariantClasses & Intent<any>) | undefined'.
//       Type 'void' is not assignable to type '(VariantClasses & Intent<any>) | undefined'.
addRenderIntent(variantIntent, (intents)=>{
    const className = useMemo(()=>{
        return intents ? Object.values(intents).join(' ') : '';
    }, [
        intents
    ]);
    if (className) {
        return [
            {
                className
            }
        ];
    }
});

//# sourceMappingURL=variants.js.map